import { useState, useEffect } from 'react';
import { getLatestMeasurements, getMeasurements } from '../services/measurements';

/**
 * Hook to fetch the latest measurements of a patient.
 */
export const useLatestMeasurements = (patientUUID) => {
    const [data, setData] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!patientUUID) return;
        setLoading(true);
        getLatestMeasurements(patientUUID)
            .then(setData)
            .catch(setError)
            .finally(() => setLoading(false));
    }, [patientUUID]);

    return { data, isLoading, error };
};

/**
 * Hook to fetch measurements of a given type for a patient and date range.
 */
export const useMeasurements = (patientUUID, type, qi, qf) => {
    const [data, setData] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!patientUUID || !type || !qi || !qf) return;
        setLoading(true);
        getMeasurements(patientUUID, type, qi, qf)
            .then(setData)
            .catch(setError)
            .finally(() => setLoading(false));
    }, [patientUUID, type, qi, qf]);

    return { data, isLoading, error };
};
